/** Load a Google-Fonts stylesheet into <head> so an override's families render before the vars point at
 * them (deduped by importUrl; a stale link is harmless). Shared by the live preview + the chat specimens. */
export const ensureMotifPreviewFontLink = (importUrl: string | undefined): void => {
  if (!importUrl || typeof document === 'undefined') return;
  if (document.querySelector(`link[data-ww-preview-font="${CSS.escape(importUrl)}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = importUrl;
  link.setAttribute('data-ww-preview-font', importUrl);
  document.head.appendChild(link);
};
